
import { defineComponent } from 'vue';
import BubbleCard from '~/components/Cards/BubbleCard.vue';
import PaymentSettings from '@/components/Payments/PaymentSettings.vue';
import SimpleStepper from '~/components/Wizards/SimpleStepWizard.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import PortalIntro from '@/components/common/Dialogs/PortalIntro.vue';

export default defineComponent({
  name: 'PaymentSetup',

  components: { ResponsiveContainer, BubbleCard, PaymentSettings, SimpleStepper },

  computed: {
    hasPaymentMethod(): boolean {
      return this.$store.getters['PaymentOptions/hasVerifiedPaymentMethods'];
    },

    isFirstLogin(): boolean {
      return this.$store.getters['User/isFirstLogin'];
    }
  },

  async mounted() {
    if (this.isFirstLogin) {
      this.$dialog({ component: PortalIntro });
    }
  },

  watch: {
    hasPaymentMethod(isSetup: boolean) {
      if (isSetup) {
        this.$router.push({ name: 'home' });
      }
    }
  }
});
